import {useCallback} from 'react';

import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';

import {ZmSwitch} from 'Components/ZmInputs';
import {setWeekendStatus} from 'Store/HostSettingsStore';


const WeekendSwitch = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const weekendStatus = useSelector((state) => state.hostSettingsState?.weekendStatus);

  const handleToggle = useCallback((e) => {
    dispatch(setWeekendStatus(!e.target.checked));
  }, [dispatch]);

  return (
    <Stack direction="row">
      <ZmSwitch
        size="small"
        data-testid="weekendSwitch"
        checked={!weekendStatus}
        onChange={handleToggle}
        onKeyDown={handleToggle}
      />
      <Typography sx={{marginLeft: '8px', whiteSpace: 'nowrap', fontSize: '0.875rem'}}>
        {t('integration.WorkWeek')}
      </Typography>
    </Stack>
  );
};

export default WeekendSwitch;
